import U from "../../felles/Utils";
import { TableHeaders } from "../../models/Headers";
import NN05Employee from "../../models/NN05Employee";
import pageImpl from "../../models/PageImpl";
import ApiResponse from "../../models/payload/APIResponse";
import * as actionTypesNN05 from "../actions/actionTypesNN05";
import * as fromApp from "../rootReducer";

export interface FeatureState extends fromApp.AppState {
  state: NN05;
}

export interface NN05 {
  page: pageImpl<NN05Employee>;
  redirectPath: string;
  error: any;
  tableHeaders: TableHeaders[];
  isFetchingNN05ListEmployee: boolean;
  order?: string;
  orderBy?: string;
  isReset: boolean;
  isResetFormEnabled: boolean;
  keyValuePairs4NN05: { key: string; value: any }[];
  currentRowFocused: number;
  scrollTopPosition: number;
  transStateInsertEmployee: number;
  transStateUpdateEmployee: number;
  transStateDeleteEmployee: number;
  transStateDialogEmployee: number;
  transDialogEmployeeFeedback: ApiResponse;
  selectedEmployee: NN05Employee; // Optional, used for selected employee in the list
  listFormData?: any;
  subFormData?: any;
  rowData?: any;
  employeeId: string;
  doesEmployeeIdExist: string;
  locationByPostalCode: string;
  stateKeypressed: number;
}

const initialState = {
  page: new pageImpl(),
  redirectPath: "/",
  error: undefined,
  tableHeaders: [],
  isFetchingNN05ListEmployee: false,
  order: '',
  orderBy: '',
  isReset: false,
  isResetFormEnabled: false,
  keyValuePairs4NN05: [],
  currentRowFocused: -1,
  scrollTopPosition: 0,
  transStateInsertEmployee: 0,
  transStateUpdateEmployee: 0,
  transStateDeleteEmployee: 0,
  transStateDialogEmployee: 0,
  transDialogEmployeeFeedback: {} as ApiResponse, // Initialize as empty object
  selectedEmployee: {} as NN05Employee, // Initialize as empty object},
  listFormData: {} as any, // Initialize as empty object},
  subFormData: {} as any, // Initialize as empty object},
  rowData: {} as any, // Initialize as empty object},
  employeeId: '',
  doesEmployeeIdExist: '',
  locationByPostalCode: '',
  stateKeypressed: -1,
} as NN05;


export const setLockKeypressed = (state: NN05, action: any) => {
  return U.updateStore(state, { stateKeypressed: action.payload });
};

export const setTransDialogEmployeeFeedback = (state: NN05, action: any) => {
  return U.updateStore(state, { transDialogEmployeeFeedback: action.payload });
};

export const setTransStateInsertEmployee = (state: NN05, action: any) => {
  return U.updateStore(state, { transStateInsertEmployee: action.payload });
};

export const setTransStateUpdateEmployee = (state: NN05, action: any) => {
  return U.updateStore(state, { transStateUpdateEmployee: action.payload });
};

export const setTransStateDeleteEmployee = (state: NN05, action: any) => {
  return U.updateStore(state, { transStateDeleteEmployee: action.payload });
};

export const setTransStateDialogEmployee = (state: NN05, action: any) => {
  return U.updateStore(state, { transStateDialogEmployee: action.payload });
};

export const setSelectedEmployee = (state: NN05, action: any) => {
  return U.updateStore(state, { selectedEmployee: action.payload });
};

const setScrollTopPosition = (state: NN05, action: any) => {
  return U.updateStore(state, { scrollTopPosition: action.payload });
}

const setKeyValuePairs4NN05 = (state: NN05, action: any) => {
  return U.updateStore(state, { keyValuePairs4NN05: action.payload });
};

const setCurrentRowFocused = (state: NN05, action: any) => {
  return U.updateStore(state, { currentRowFocused: action.payload });
};
//
const NN05ListeGetStart = (state: NN05) => {
  return U.updateStore(state, { isFetchingNN05Liste: true });
};
//
const NN05ListeGetSuccess = (state: NN05, action: any) => {
  return U.updateStore(state, {
    page: action.payload,
    isFetchingNN05Liste: false,
  });
};
//
const NN05ListeGetFailed = (state: NN05, action: any) => {
  return U.updateStore(state, { isFetchingNN05Liste: false, error: action });
};
//  Reset form
const NN05ResetForm = (state: NN05, action: any) => {
  if (action.payload) {
    return U.updateStore(state, { isReset: true, page: new pageImpl(), tableHeaders: [] });
  } else {
    return U.updateStore(state, { isReset: false });
  }
};
//  Set Reset state enabled
const NN05SetResetFormEnabled = (state: NN05, action: any) => {
  return U.updateStore(state, { isResetFormEnabled: action.payload });
};
//
const NN05ClearComponentStore = (state: NN05) => {
  return U.updateStore(state, { ...initialState });
};
//  Update column header list
//  This is used to update the column headers in the NN05 component
const NN05UpdateColumnHeaderList = (state: NN05, list: TableHeaders[]) => {
  return U.updateStore(state, { tableHeaders: list });
};

const getEmployeeIdSuccess = (state: NN05, action: any) => {
  return U.updateStore(state, { employeeId: action.payload });
};
//
const getEmployeeIdFailed = (state: NN05, action: any) => {
  return U.updateStore(state, { employeeId: action.payload });
};

const getEmployeeIdValidateSuccess = (state: NN05, action: any) => {
  return U.updateStore(state, { employeeId: action.payload.employeeId, doesEmployeeIdExist: action.payload.message });
};

const getEmployeeIdValidateFailed = (state: NN05, action: any) => {
  return U.updateStore(state, {employeeId: action.payload.employeeId,  doesEmployeeIdExist:action.payload.message });
};

const getLocationByPostalCodeSuccess = (state: NN05, action: any) => {
  return U.updateStore(state, { locationByPostalCode: action.payload.postalLocation });
}

const getLocationByPostalCodeFailed = (state: NN05, action: any) => {
  return U.updateStore(state, { locationByPostalCode: action.payload });
};

const setListFormData = (state: NN05, action: any) => {
  return U.updateStore(state, { listFormData: action.payload });
};

const setSubFormData = (state: NN05, action: any) => {
  return U.updateStore(state, { subFormData: action.payload });
};

const setRowData = (state: NN05, action: any) => {
  return U.updateStore(state, { rowData: action.payload });
};

//  Reducer for NN05
const NN05 = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypesNN05.NN05_EMPLOYEELIST_GET_INIT:
      return NN05ListeGetStart(state);
    case actionTypesNN05.NN05_EMPLOYEELIST_GET_SUCCESS:
      return NN05ListeGetSuccess(state, action);
    case actionTypesNN05.NN05_EMPLOYEELIST_GET_FAILED:
      return NN05ListeGetFailed(state, action);
    case actionTypesNN05.NN05_RESET_FORM:
      return NN05ResetForm(state, action);
    case actionTypesNN05.NN05_SET_COLUMN_HEADER_LIST:
      return NN05UpdateColumnHeaderList(state, action.list);
    case actionTypesNN05.NN05_RESET_COMPONENT_STORE:
      return NN05ClearComponentStore(state);
    case actionTypesNN05.NN05_SET_RESET_FORM_ENABLED:
      return NN05SetResetFormEnabled(state, action);
    case actionTypesNN05.SET_KEY_VALUE_PAIRS_4_NN05:
      return setKeyValuePairs4NN05(state, action);
    case actionTypesNN05.SET_CURRENT_ROW_FOCUSED:
      return setCurrentRowFocused(state, action);
    case actionTypesNN05.SET_SCROLL_TOP_POSITION:
      return setScrollTopPosition(state, action);
    case actionTypesNN05.SET_TRANS_STATE_INSERT_PERSON:
      return setTransStateInsertEmployee(state, action);
    case actionTypesNN05.SET_TRANS_STATE_UPDATE_PERSON:
      return setTransStateUpdateEmployee(state, action);
    case actionTypesNN05.SET_TRANS_STATE_DELETE_PERSON:
      return setTransStateDeleteEmployee(state, action);
    case actionTypesNN05.SET_TRANS_STATE_DIALOG_PERSON:
      return setTransStateDialogEmployee(state, action);
    case actionTypesNN05.SET_SELECTED_PERSON:
      return setSelectedEmployee(state, action);
    case actionTypesNN05.SET_TRANS_DIALOG_EMPLOYEE_FEEDBACK:
      return setTransDialogEmployeeFeedback(state, action);
    case actionTypesNN05.NN05_EMPLOYEE_ID_GET_SUCCESS:
      return getEmployeeIdSuccess(state, action);
    case actionTypesNN05.NN05_EMPLOYEE_ID_GET_FAILED:
      return getEmployeeIdFailed(state, action);
    case actionTypesNN05.NN05_EMPLOYEE_ID_VALIDATE_GET_SUCCESS:
      return getEmployeeIdValidateSuccess(state, action);
    case actionTypesNN05.NN05_EMPLOYEE_ID_VALIDATE_GET_FAILED:
      return getEmployeeIdValidateFailed(state, action);
    case actionTypesNN05.NN05_LOCATION_BY_POSTALCODE_GET_SUCCESS:
      return getLocationByPostalCodeSuccess(state, action);
    case actionTypesNN05.NN05_LOCATION_BY_POSTALCODE_GET_FAILED:
      return getLocationByPostalCodeFailed(state, action);
    case actionTypesNN05.SET_LIST_FORMDATA:
      return setListFormData(state, action);
    case actionTypesNN05.SET_SUB_FORMDATA:
      return setSubFormData(state, action)
    case actionTypesNN05.SET_ROWDATA:
      return setRowData(state, action)
    case actionTypesNN05.SET_LOCK_KEYPRESS:
      return setLockKeypressed(state, action)
    default:
      return state;
  }
};

export default NN05;









